// src/routes/signup.tsx
import { createFileRoute, redirect } from "@tanstack/react-router";
import { SignUpForm } from "@/auth/components/sign-up-form";

import { z } from "zod";

const signUpSearchSchema = z.object({
	redirect: z.string().optional(),
});

export const Route = createFileRoute("/_public/_auth/sign-up")({
	validateSearch: signUpSearchSchema,
	component: SignUpPage,
});

function SignUpPage() {
	const { redirect } = Route.useSearch();

	return (
		<div className="flex min-h-screen items-center justify-center px-4">
			<SignUpForm className="w-full max-w-4xl" redirectUrl={redirect} />
		</div>
	)
}
